<template>
  <div class="scene-checkpoint-plot">
    <BackButton @back="onBack" />

    <img class="sprite .hu__hu__" src="/images/game/sprite-3.png" />

    <div class="title">
      <img :src="title" />
    </div>

    <div class="dialog" @click="handleClick">
      <div class="title">亲爱的：</div>
      <div class="content">{{content}}</div>
    </div>
  </div>
</template>

<script>
import BackButton from "../common/BackButton";
import TypingText from "../common/TypingText";

export default {
  name: "CheckpointPlotScene",
  components: {
    BackButton,
    TypingText
  },
  computed: {
    title: function() {
      return `/images/game/cp-${this.$store.state.game.currentCheckpointId}-title.png`;
    },
    content: function() {
      return `本轮关卡请亲爱的${this.$store.state.sys.sysUser.me.nickName}和小悦一起摘葡萄吧，采摘是酿造葡萄酒的第一步! 记住每一道题只有 15s 的答题时间噢，请加油答题!`;
    }
  },
  created() {
    this.$emit("changeBackgroundMusic", "/music/主背景音乐（场景2、3、4）.mp3");
  },
  methods: {
    handleClick() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "CheckpointStartScene");
    },
    onBack() {
      this.$emit("changeScene", "MainScene");
    }
  }
};
</script>


<style lang="scss" scoped>
@keyframes ani {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.scene-checkpoint-plot {
  width: 1100px;
  height: 560px;
  position: relative;

  background-image: url(/images/game/checkpoint-background.png);
  background-size: cover;
  animation: ani 1.5s;

  .back-button {
    position: absolute;
    width: 80px;
    height: 40px;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  @keyframes spritemove {
    from {
      left: -310px;
    }

    to {
      left: 148px;
    }
  }

  @keyframes huhu {
    50% {
      transform: translateY(20px);
    }
  }
  .sprite {
    position: absolute;
    top: 230px;
    left: 148px;
    width: 310px;
    height: 325px;

    animation: spritemove 1.5s, huhu 2s infinite;
  }

  .title {
    text-align: center;
    img {
      margin-top: 50px;
      height: 162px;
    }
  }

  @keyframes dialogmove {
    from {
      right: -482px;
    }

    to {
      right: 183px;
    }
  }

  .dialog {
    position: absolute;
    top: 280px;
    right: 183px;
    width: 482px;
    height: 230px;

    animation: dialogmove 1.5s;

    background: url(/images/game/dialog-background.png);
    background-size: cover;

    .title {
      text-align: left;
      width: 355px;
      margin: 30px auto 10px auto;
      font-size: 32px;
      font-family: "FZFMJW";
      font-weight: normal;
      color: rgba(0, 0, 0, 1);
      line-height: 36px;
    }

    .content {
      width: 355px;
      margin: 0 auto;
      font-size: 18px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 41px;
    }
  }
}
</style>